(function(w) {
  'use strict';

  // Pg.Cart module
  Pg.Cart = {
    
    // Flag to track if user has clicked add to cart
    userTriedAddToCart: false,
    
    init() {  
      // Add event listener for Add to Cart button
      var a2cbtn = S$Q('.dp_st__atc-btn');
      if (a2cbtn) {
        a2cbtn.addEventListener('click', this.addToCartWithProducts.bind(this));
      }

      // Set up upload progress monitoring
      this.setupUploadProgressMonitoring();
    },

    setupUploadProgressMonitoring() {
      // Listen for upload progress updates
      if (Pg.State) {
        Pg.State.on('upload:status-changed', (event) => {
          this.updateAddToCartButton();
        });

        Pg.State.on('upload:queue-added', (event) => {
          this.updateAddToCartButton();
        });

        Pg.State.on('upload:queue-removed', (event) => {
          this.updateAddToCartButton();
        });

        Pg.State.on('upload:queue-updated', (event) => {
          this.updateAddToCartButton();
        });
      }
    },

    waitForUploadsAndAddToCart() {
      const checkUploads = () => {
        const computed = w.Pg.State?.data?.computed;
        if (!computed) {
          console.warn('⚠️ State not available, cannot check uploads');
          this.userTriedAddToCart = false;
          return;
        }

        // Update button state
        this.updateAddToCartButton();

        if (computed.uploadProgress.hasFailures) {
          console.warn('⚠️ Uploads failed, cannot add to cart');
          this.userTriedAddToCart = false;
          return;
        }

        if (computed.canAddToCart) {
          console.log('✅ Uploads complete, proceeding with add to cart');
          // Small delay to ensure UI updates
          setTimeout(() => {
            this.proceedWithAddToCart();
          }, 500);
          return;
        }

        if (computed.uploadProgress.hasUploading || !computed.uploadProgress.isComplete) {
          // Still uploading, check again in 1 second
          setTimeout(checkUploads, 1000);
          return;
        }

        // Something went wrong
        console.warn('⚠️ Upload state unclear, cannot proceed');
        this.userTriedAddToCart = false;
      };

      // Start checking
      checkUploads();
    },

    proceedWithAddToCart() {
      // Reset the flag to avoid infinite loops
      const wasUserTriedAddToCart = this.userTriedAddToCart;
      this.userTriedAddToCart = false;
      
      // Call the main add to cart logic, but skip the upload checks
      this.performAddToCart();
    },

    performAddToCart() {
      // Simply call the existing addToCartWithProducts logic but without the upload checks
      // since we know uploads are complete at this point
      const frames = w.Pg.State.data.frames;
      
      // Verify all frames have filestack URLs
      const framesWithoutUrls = frames.filter(f => !f.image?.filestackUrl);
      if (framesWithoutUrls.length > 0) {
        console.warn(`⚠️ ${framesWithoutUrls.length} frame(s) missing filestack URLs`);
        return false;
      }
      
      // Show loading state
      const a2cbtn = document.querySelector('.dp_st__atc-btn');
      if (a2cbtn) {
        a2cbtn.classList.add('loading');
        a2cbtn.innerText = 'Processing...';
      }

      // Create items array for cart
      const items = [];
      
      // Process each frame (using the same logic as addToCartWithProducts)
      frames.forEach(frame => {
        const { acrylic, border, cssStyles, id, image, size, variantID, borderPx, bw } = frame;
        let hie = size?.height;
        let wei = size?.width;
        
        if(acrylic.toString() == "true"){
          var acr2add = w.Pg.Utils.findVariantByKeySubstring(`${Math.min(wei,hie)}x${Math.max(wei,hie)}`); 
          if(acr2add?.id){
            items.push({
              id: acr2add.id.toString(),
              quantity: 1,
              properties: {
                "_parent_frameid_": id,
              }  
            });
          } else {
            console.warn("⚠️ Skipping acrylic add-on — no valid variant ID found:", acr2add);
          }
        }

        // Safely add crop to filestack URL with error handling
        let addedCrop = image?.filestackUrl;
        let addedVCrop = image?.filestackUrl;
        
        try {
          if (image?.filestackUrl && window.Pg?.Utils?.addCropToFilestackUrl) {
            addedCrop = window.Pg.Utils.addCropToFilestackUrl(image.filestackUrl, image.crop, borderPx || 0, bw);
          }
        } catch (error) {
          console.warn('⚠️ Error adding crop to filestack URL:', error);
          addedCrop = image?.filestackUrl;
        }

        try {
          if (image?.filestackUrl && image?.visableCrop && typeof image.visableCrop === 'string' && window.Pg?.Utils?.addCropToFilestackUrl) {
            addedVCrop = window.Pg.Utils.addCropToFilestackUrl(image.filestackUrl, image.visableCrop, 0, bw);
          }
        } catch (error) {
          console.warn('⚠️ Error adding visible crop to filestack URL:', error);
          addedVCrop = image?.filestackUrl;
        }

        const s3Img = window.Pg.Utils.generateS3Url();
        const gcsImg = s3Img.replace('https://ffpf.s3.us-west-1.amazonaws.com/', 'https://storage.googleapis.com/pf4ff/');

        let mainFrameProperties = w.Pg.Frames?.getFramePropertiesById(id);

        items.push({
          id: variantID.toString(),
          quantity: 1,
          properties: {
            "_dir_": Number(wei) >= Number(hie) ? "h" : "v",
            "_frameid_": id,
            "_width_": size?.width,
            "_height_": size?.height,
            "_acrylic_": acrylic.toString(),
            "_acrylic-price_": acrylic.toString() == "true" ? acr2add?.price : 0,
            "_border_": border,
            "_varId_": variantID.toString(),
            "_full-img_": image?.filestackUrl,
            "_cropedImg_": addedCrop,
            "_visCropedImg_": addedVCrop,
            "_visCropCords_": image?.visableCrop,
            "_cropCords_": image?.crop,
            "_s3Img_": s3Img + ".png",
            "_s3Pdf_": s3Img + ".pdf",
            "_gcsImg_": gcsImg + ".png",
            "_gcsPdf_": gcsImg + ".pdf",
            "_borderPx_": borderPx,
            "_bw_": bw.toString(),
            "_mainFrame_":  JSON.stringify(mainFrameProperties),
          }  
        });
      });
      
      // Check if we have items to add
      if (!items.length) {
        console.warn('⚠️ No valid items found to add to cart');
        return false;
      }
      
      // Add items to cart via AJAX
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items })
      })
      .then(response => response.json())
      .then(data => {
        cLog('✅ Items added to cart:', data);
        
        // Clear all frames from state/database before redirecting
        this.clearAllFrames();
        
        // Reset button state
        if (a2cbtn) {
          a2cbtn.classList.remove('loading');
          a2cbtn.innerText = 'Added To Cart';
          w.location.href = '/cart';
        }
      })
      .catch(error => {
        console.error('❌ Error adding items to cart:', error);
        
        // Reset button state on error
        if (a2cbtn) {
          a2cbtn.classList.remove('loading');
          a2cbtn.innerText = 'Try Again';
          
          setTimeout(() => {
            a2cbtn.innerText = 'Add To Cart';
          }, 3000);
        }
      });
      
      return true;
    },

    updateAddToCartButton() {
      const atcBtn = document.querySelector('.dp_st__atc-btn');
      if (!atcBtn) return;

      let atcBtnText;

      if(atcBtn.innerText.indexOf("$") > -1){
        atcBtnText = atcBtn.innerText;
      }else{
        atcBtnText = "Add To Cart";
      }
      ;

      const state = Pg.State?.data;
      if (!state) return;

      const { computed } = state;
      const { uploadProgress, canAddToCart } = computed;

      // Remove existing classes
      atcBtn.classList.remove('loading', 'uploading', 'disa');

      if (!computed.hasFrames) {
        // No frames
        // atcBtn.classList.add('disa');
        atcBtn.innerText = atcBtnText;
        return;
      }

      // Only show uploading state if user has clicked add to cart
      if (this.userTriedAddToCart && (uploadProgress.hasUploading || (uploadProgress.total > 0 && !uploadProgress.isComplete))) {
        // Uploads in progress and user tried to add to cart - keep button enabled
        atcBtn.classList.add('uploading');
        const completed = uploadProgress.completed;
        const total = uploadProgress.total;
        atcBtn.innerText = `Uploading ${completed}/${total}...`;
        return;
      }

      if (uploadProgress.hasFailures) {
        // Has failed uploads
        atcBtn.classList.add('disa');
        atcBtn.innerText = 'Upload Failed - Try Again';
        return;
      }

      if (canAddToCart) {
        // Ready to add to cart - reset flag if uploads are complete
        if (this.userTriedAddToCart && uploadProgress.isComplete) {
          this.userTriedAddToCart = false;
        }
        atcBtn.innerText = atcBtnText;
        return;
      }

      // If we have frames, always keep button enabled (uploads happen in background)
      if (computed.hasFrames) {
        atcBtn.innerText = atcBtnText;
        return;
      }

      // Only disable if no frames at all
      // atcBtn.classList.add('disa');
      atcBtn.innerText = atcBtnText;
    },
    /**
     * Add frames to cart with products
     * Handles the main "Add to Cart" operation for all frames
     * @returns {Promise<boolean>} - Success status
     */
    async addToCartWithProducts() {
      cLog('🛒 Pg.Cart: Adding all frames to cart');
      
      // Set flag that user has tried to add to cart
      this.userTriedAddToCart = true;
      
      try {
        // Check if there are frames to add
        const frames = w.Pg.State.data.frames;
        if (!frames.length) {
          console.warn('⚠️ No frames found to add to cart');
          this.userTriedAddToCart = false;
          this.allowAtcWithoutPhoto();
          return false;
        }

        

        // Save crop to all frames before adding to cart
        try {
          cLog('💾 Pg.Cart: Saving crop to all frames before add to cart');
          if (w.Pg?.Images?.saveCrop) {
            // Call saveCrop and wait for DOM operations to complete
            w.Pg.Images.saveCrop(true);
            cLog('✅ Crop saved to all frames successfully');
            
            // Wait for DOM updates to complete before syncing to state
            await new Promise(resolve => setTimeout(resolve, 100));
            
            // Sync crop data from DOM to state
            const domFrames = document.querySelectorAll('.framefh');
            domFrames.forEach(domFrame => {
              const frameId = domFrame.dataset.frameId;
              if (frameId && w.Pg?.State?.getFrame) {
                const stateFrame = w.Pg.State.getFrame(frameId);
                if (stateFrame && stateFrame.image) {
                  const updatedImageData = {
                    ...stateFrame.image,
                    crop: domFrame.dataset.crop || stateFrame.image.crop,
                    visableCrop: domFrame.dataset.visableCrop || stateFrame.image.visableCrop,
                    borderPx: domFrame.dataset.borderPx || stateFrame.image.borderPx
                  };
                  
                  w.Pg.State.updateFrame(frameId, {
                    image: updatedImageData
                  });
                }
              }
            });
            cLog('✅ Crop data synced from DOM to state');
          } else {
            console.warn('⚠️ Pg.Images.saveCrop function not available');
          }
        } catch (cropError) {
          console.error('❌ Error saving crop to frames:', cropError);
          // Continue with add to cart even if crop save fails
        }

        // Check if all uploads are complete
        const computed = w.Pg.State.data.computed;
        if (!computed.canAddToCart) {
          // DETAILED DEBUG LOGGING to understand why canAddToCart is false
          console.group('🔍 DETAILED Add to Cart Debug Analysis');
          
          // 1. Overall computed state
          console.log('📊 Full Computed State:', JSON.stringify(computed, null, 2));
          
          // 2. Frame analysis
          console.group('📋 Frame Analysis');
          console.log(`Total frames in state: ${frames.length}`);
          frames.forEach((frame, index) => {
            console.group(`Frame ${index + 1} (ID: ${frame.id})`);
            console.log('✅ Basic Info:', {
              id: frame.id,
              variantID: frame.variantID,
              hasVariantID: !!frame.variantID,
              size: frame.size,
              acrylic: frame.acrylic,
              border: frame.border
            });
            console.log('🖼️ Image Info:', {
              hasImage: !!frame.image,
              hasFile: !!frame.image?.file,
              hasFilestackUrl: !!frame.image?.filestackUrl,
              status: frame.image?.status,
              fileName: frame.image?.file?.name,
              fileSize: frame.image?.file?.size,
              filestackUrl: frame.image?.filestackUrl ? 'Present' : 'Missing',
              crop: frame.image?.crop,
              visableCrop: frame.image?.visableCrop
            });
            
            // Check if frame meets requirements
            const frameValid = !!(frame.variantID && frame.image?.filestackUrl);
            console.log(`🎯 Frame Valid: ${frameValid ? '✅' : '❌'}`, {
              hasVariantID: !!frame.variantID,
              hasFilestackUrl: !!frame.image?.filestackUrl
            });
            console.groupEnd();
          });
          console.groupEnd();
          
          // 3. Upload queue analysis
          console.group('📤 Upload Queue Analysis');
          const uploadQueue = w.Pg.State.data.uploadQueue || [];
          console.log(`Upload queue length: ${uploadQueue.length}`);
          uploadQueue.forEach((upload, index) => {
            console.log(`Upload ${index + 1}:`, {
              frameId: upload.frameId,
              status: upload.status,
              progress: upload.progress,
              error: upload.error,
              file: upload.file ? {
                name: upload.file.name,
                size: upload.file.size,
                type: upload.file.type
              } : 'No file'
            });
          });
          console.groupEnd();
          
          // 4. Upload progress breakdown
          console.group('📊 Upload Progress Breakdown');
          const up = computed.uploadProgress;
          console.log('Upload Progress Details:', {
            total: up.total,
            completed: up.completed,
            uploading: up.uploading,
            failed: up.failed,
            pending: up.pending,
            isComplete: up.isComplete,
            hasUploading: up.hasUploading,
            hasFailures: up.hasFailures,
            hasCompleted: up.hasCompleted
          });
          console.groupEnd();
          
          // 5. Computed flags analysis
          console.group('🚩 Computed Flags Analysis');
          console.log('Key Computed Flags:', {
            hasFrames: computed.hasFrames,
            canAddToCart: computed.canAddToCart,
            allFramesHaveImages: computed.allFramesHaveImages,
            allFramesHaveVariants: computed.allFramesHaveVariants,
            allFramesReady: computed.allFramesReady
          });
          console.groupEnd();
          
          // 6. Individual requirement checks with specific reasons
          console.group('🔍 Requirement Check Breakdown');
          
          if (computed.uploadProgress.hasUploading) {
            console.warn('❌ REASON: Uploads currently in progress');
            console.log('⏳ Uploads in progress, waiting for completion...');
            console.groupEnd();
            console.groupEnd();
            // Update button to show upload progress
            this.updateAddToCartButton();
            // Wait for uploads to complete, then try again
            this.waitForUploadsAndAddToCart();
            return true; // Return true as we're handling the request
          }
          
          if (computed.uploadProgress.hasFailures) {
            console.warn('❌ REASON: Some uploads have failed');
            const failedUploads = uploadQueue.filter(u => u.status === 'failed');
            console.log('Failed uploads:', failedUploads);
            console.groupEnd();
            console.groupEnd();
            this.userTriedAddToCart = false;
            return false;
          }
          
          if (!computed.hasFrames) {
            console.warn('❌ REASON: No frames found in state');
            console.log('Frames array length:', frames.length);
            console.groupEnd();
            console.groupEnd();
            this.userTriedAddToCart = false;
            return false;
          }
          
          if (!computed.uploadProgress.isComplete) {
            console.warn('❌ REASON: Upload progress not marked as complete');
            console.log('Upload completion details:', {
              total: up.total,
              completed: up.completed,
              isComplete: up.isComplete,
              calculatedComplete: up.completed === up.total && up.total > 0
            });
            console.groupEnd();
            console.groupEnd();
            this.userTriedAddToCart = false;
            return false;
          }
          
          // Check individual frame requirements
          const framesWithoutVariants = frames.filter(f => !f.variantID);
          if (framesWithoutVariants.length > 0) {
            console.warn('❌ REASON: Some frames missing variant IDs');
            console.log('Frames without variants:', framesWithoutVariants.map(f => ({
              id: f.id,
              variantID: f.variantID
            })));
            console.groupEnd();
            console.groupEnd();
            this.userTriedAddToCart = false;
            return false;
          }
          
          const framesWithoutUrls = frames.filter(f => !f.image?.filestackUrl);
          if (framesWithoutUrls.length > 0) {
            console.warn('❌ REASON: Some frames missing filestack URLs');
            console.log('Frames without URLs:', framesWithoutUrls.map(f => ({
              id: f.id,
              hasImage: !!f.image,
              hasFile: !!f.image?.file,
              hasFilestackUrl: !!f.image?.filestackUrl,
              status: f.image?.status
            })));
            console.groupEnd();
            console.groupEnd();
            this.userTriedAddToCart = false;
            return false;
          }
          
          // If we get here, check the computed.canAddToCart logic itself
          console.warn('❌ REASON: Unknown - computed.canAddToCart is false despite passing all checks');
          console.log('🔧 Suggestion: Check Pg.State.updateComputed() logic for canAddToCart calculation');
          
          // Additional state validation
          console.group('🔧 Additional State Validation');
          console.log('State structure check:', {
            hasState: !!w.Pg?.State,
            hasStateData: !!w.Pg?.State?.data,
            hasComputed: !!w.Pg?.State?.data?.computed,
            hasFramesArray: Array.isArray(w.Pg?.State?.data?.frames),
            hasUploadQueue: Array.isArray(w.Pg?.State?.data?.uploadQueue)
          });
          console.groupEnd();
          
          console.groupEnd();
          console.groupEnd();
          
          this.userTriedAddToCart = false;
          return false;
        }

        // Verify all frames have filestack URLs
        const framesWithoutUrls = frames.filter(f => !f.image?.filestackUrl);
        if (framesWithoutUrls.length > 0) {
          console.warn(`⚠️ ${framesWithoutUrls.length} frame(s) missing filestack URLs`);
          return false;
        }
        
        // Show loading state
        const a2cbtn = document.querySelector('.dp_st__atc-btn');
        if (a2cbtn) {
          a2cbtn.classList.add('loading');
          a2cbtn.innerText = 'Processing...';
        }

        // Create items array for cart
        const items = [];
        
        // Process each frame
        frames.forEach(frame => {
           const { acrylic,border, cssStyles,id,image,size,variantID, borderPx , bw} = frame;
        let hie = size?.height;
        let wei = size?.width;
        if(acrylic.toString() == "true"){
            var acr2add = w.Pg.Utils.findVariantByKeySubstring(`${Math.min(wei,hie)}x${Math.max(wei,hie)}`); 
            if(acr2add?.id){
              items.push({
                  id: acr2add.id.toString(),
                  quantity: 1,
                  properties: {
                      "_parent_frameid_": id,
                  }  
              });
            }else{
              console.warn("⚠️ Skipping acrylic add-on — no valid variant ID found:", acr2add);
            }
           
        }
 
        // Safely add crop to filestack URL with error handling
        let addedCrop = image?.filestackUrl;
        let addedVCrop = image?.filestackUrl;
        
        try {
          if (image?.filestackUrl && window.Pg?.Utils?.addCropToFilestackUrl) {
            addedCrop = window.Pg.Utils.addCropToFilestackUrl(image.filestackUrl, image.crop || 0, borderPx || 0, bw);
          }
        } catch (error) {
          console.warn('⚠️ Error adding crop to filestack URL:', error);
          addedCrop = image?.filestackUrl;
        }

        try {
          if (image?.filestackUrl && image?.visableCrop && typeof image.visableCrop === 'string' && window.Pg?.Utils?.addCropToFilestackUrl) {
            addedVCrop = window.Pg.Utils.addCropToFilestackUrl(image.filestackUrl, image.visableCrop, 0, bw);
          }
        } catch (error) {
          console.warn('⚠️ Error adding visible crop to filestack URL:', error);
          addedVCrop = image?.filestackUrl;
        }

        const s3Img = window.Pg.Utils.generateS3Url();
        const gcsImg = s3Img.replace('https://ffpf.s3.us-west-1.amazonaws.com/', 'https://storage.googleapis.com/pf4ff/');

        let mainFrameProperties = w.Pg.Frames?.getFramePropertiesById(id);

         items.push({
            id: variantID.toString(),
            quantity: 1,
            properties: {
                "_dir_": Number(wei) >= Number(hie) ? "h" : "v",
                "_frameid_": id,
                "_width_": size?.width,
                "_height_": size?.height,
                "_acrylic_": acrylic.toString(),
                "_acrylic-price_": acrylic.toString() == "true" ? acr2add?.price : 0,
                "_border_": border,
                "_varId_": variantID.toString(),
                "_full-img_": image?.filestackUrl,
                "_cropedImg_": addedCrop,
                "_visCropedImg_": addedVCrop,
                "_visCropCords_": image?.visableCrop,
                "_cropCords_": image?.crop,
                "_s3Img_": s3Img + ".png",
                "_s3Pdf_": s3Img + ".pdf",
                "_gcsImg_": gcsImg + ".png",
                "_gcsPdf_": gcsImg + ".pdf",
                "_borderPx_": borderPx,
                "_bw_": bw.toString(),
                "_mainFrame_":  JSON.stringify(mainFrameProperties)
            }  
        });
        });
        
        // Check if we have items to add
        if (!items.length) {
          console.warn('⚠️ No valid items found to add to cart');
          return false;
        }
        // Add items to cart via AJAX
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        })
              .then(response => response.json())
      .then(data => {
        cLog('✅ Items added to cart:', data);
        
        // Clear all frames from state/database before redirecting
        this.clearAllFrames();
        
        // Reset button state
        if (a2cbtn) {
          a2cbtn.classList.remove('loading');
          a2cbtn.innerText = 'Added To Cart';
          w.location.href = '/cart';
        }
      })
        .catch(error => {
          console.error('❌ Error adding items to cart:', error);
          
          // Reset button state on error
          if (a2cbtn) {
            a2cbtn.classList.remove('loading');
            a2cbtn.innerText = 'Try Again';
            
            setTimeout(() => {
              a2cbtn.innerText = 'Add To Cart';
            }, 3000);
          }
        });
        
        return true;
      } catch (error) {
        console.error('❌ Error in addToCartWithProducts:', error);
        
        // Reset button state on error
        const a2cbtn = document.querySelector('.dp_st__atc-btn');
        if (a2cbtn) {
          a2cbtn.classList.remove('loading');
          a2cbtn.innerText = 'Error - Try Again';
          
          setTimeout(() => {
            a2cbtn.innerText = 'Add To Cart';
          }, 3000);
        }
        
        return false;
      }
    },

    /**
     * Clear all frames from state and DOM using existing state management functions
     * @returns {boolean} - Success status
     */
    clearAllFrames() {
      cLog('🗑️ Pg.Cart: Clearing all frames using state management functions');
      
      try {
        const state = w.Pg?.State;
        if (!state || !state.data) {
          console.warn('⚠️ State not available for frame clearing');
          return false;
        }

        // Clean up blob URLs using existing function
        if (typeof state._cleanupAllBlobs === 'function') {
          state._cleanupAllBlobs();
        }

        // Clear frames array from state
        state.data.frames = [];
        
        // Clear upload queue using existing function
        if (typeof state.clearUploadQueue === 'function') {
          state.clearUploadQueue();
        }
        
        // Reset UI state
        if (state.data.ui) {
          state.data.ui.activeFrameId = null;
          state.data.ui.editMode = state.EDIT_MODES?.NONE || 'none';
        }
        
        // Update computed values using existing function
        if (typeof state.updateComputed === 'function') {
          state.updateComputed();
        }
        
        // Disable add to cart button
        const atcBtn = document.querySelector('.dp_st__atc-btn');
        if (atcBtn) {
          atcBtn.classList.add('disa');
          atcBtn.innerText = 'Add To Cart';
        }

        state.clearDB();
        
        // Trigger state update event using existing function
        if (typeof state.triggerUpdate === 'function') {
          state.triggerUpdate('frames:cleared', { clearedAt: Date.now() });
        }
        
        cLog('✅ All frames cleared successfully using state management');
        return true;
        
      } catch (error) {
        console.error('❌ Error clearing frames:', error);
        return false;
      }
    },
    
    /**
     * Build frames summary for cart display
     * @returns {boolean} - Success status
     */
    buildFramesSummary() {
      cLog('📊 Building frames summary');
      
      try {
        // Get all frames and prepare counters
        const frames = [...document.querySelectorAll('.framefh:not(.clone-f)')].filter(el => !el.closest('.dp_epu'));
        let totalPrice = 0;
        let frameCount = 0;
        let styleGroups = {};
        // Calculate totals and group by style
        frames.forEach(frame => {
          if (!frame) return;
          
          frameCount++;
          
          
          // Get frame details
          const style = frame.getAttribute('data-frame-style') || 'Unknown';
          const size = `${frame.getAttribute('data-width-in-inches')}x${frame.getAttribute('data-height-in-inches')}` || 'Unknown';
          
          // Calculate product ID for price lookup 
          const sortedSize = parseInt(frame.getAttribute('data-width-in-inches')) < parseInt(frame.getAttribute('data-height-in-inches')) 
          ? `${style}__${frame.getAttribute('data-width-in-inches')}x${frame.getAttribute('data-height-in-inches')}` 
          : `${style}__${frame.getAttribute('data-height-in-inches')}x${frame.getAttribute('data-width-in-inches')}`;
        
          const frameData = Pg.Utils.findPByKey(sortedSize);
      
          const border = frame.getAttribute('data-frame-border') || 'No Mat';
          const framePrice = parseFloat(frameData.price || 0);
          const hasAcrylic = frame.getAttribute('data-frame-acrylic') === 'true';
          const acrylicPrice = hasAcrylic ? 8 : 0; // Hardcoded price for now
          
          // Create frame identifier for grouping
          const frameKey = `${style}-${size}-${border}-${hasAcrylic ? 'acrylic' : 'no-acrylic'}`;
          
          // Add to style groups
          if (!styleGroups[frameKey]) {
            styleGroups[frameKey] = {
              style,
              size,
              border,
              hasAcrylic,
              count: 0,
              price: framePrice + acrylicPrice
            };
          }
          // Increment group count
          styleGroups[frameKey].count++;
          
          // Add to total price
          totalPrice += framePrice + acrylicPrice;
        });
        
        if(frameCount == 0) {
          const FrameWithOutFrames = document.querySelectorAll('.frame');
          const frame = FrameWithOutFrames[0]
            // Get frame details
          const style = frame.getAttribute('data-frame-style') || 'Unknown';
          const size = `${frame.getAttribute('data-width-in-inches')}x${frame.getAttribute('data-height-in-inches')}` || 'Unknown';
          
          // Calculate product ID for price lookup 
          const sortedSize = parseInt(frame.getAttribute('data-width-in-inches')) < parseInt(frame.getAttribute('data-height-in-inches')) 
          ? `${style}__${frame.getAttribute('data-width-in-inches')}x${frame.getAttribute('data-height-in-inches')}` 
          : `${style}__${frame.getAttribute('data-height-in-inches')}x${frame.getAttribute('data-width-in-inches')}`;
        
          const frameData = Pg.Utils.findPByKey(sortedSize);
      
          const border = frame.getAttribute('data-frame-border') || 'No Mat';
          const framePrice = parseFloat(frameData.price || 0);
          const hasAcrylic = frame.getAttribute('data-frame-acrylic') === 'true';
          const acrylicPrice = hasAcrylic ? 8 : 0; // Hardcoded price for now
          
          // Create frame identifier for grouping
          const frameKey = `${style}-${size}-${border}-${hasAcrylic ? 'acrylic' : 'no-acrylic'}`;
          
          // Add to style groups
          if (!styleGroups[frameKey]) {
            styleGroups[frameKey] = {
              style,
              size,
              border,
              hasAcrylic,
              count: 0,
              price: framePrice + acrylicPrice
            };
          }
          // Increment group count
          styleGroups[frameKey].count++;
          
          // Add to total price
          totalPrice += framePrice + acrylicPrice;
        }

        // Check for bulk discounts
        const discountValue = Number(w.discountP) || 0;
        const discountType = w.discountT || 'percentage';
        const discountThreshold = Number(w.discountTH) || 0;

        let discountAmount = 0;
        
        let discountedPrice = totalPrice;
        if (totalPrice >= discountThreshold && discountValue > 0) {
          if (discountType === 'percentage') {
            discountAmount = totalPrice * (discountValue / 100);
          } else if (discountType === 'fixed_amount') {
            discountAmount = Math.min(discountValue, totalPrice);
          }

          discountedPrice = Math.max(totalPrice - discountAmount, 0);
        }
        
        // Update summary UI
        const subtotalElement = document.querySelector('.dp_st .dp_st__item');
        if (subtotalElement) {
          subtotalElement.innerHTML = '';
          const subtotalEl = `
            <div class="subtotal-box fl_s_bet">
              <div>
                <p>SUBTOTAL</p>
              </div>
              <div>
                ${discountAmount > 0 ? `<span class="st_cprice">$${totalPrice.toFixed(0)}</span>` : ''}
                <span class="st_fprice">$${discountedPrice.toFixed(2)}</span>
              </div>
            </div>
            ${discountAmount > 0 ? `<div class="inc_save">Includes $${discountAmount.toFixed(2)} deal saving</div>` : ''}
          `;
          
          
          subtotalElement.insertAdjacentHTML('beforeend', subtotalEl);
          if(dType === "M") S$Q(".dp_st__atc-btn").innerHTML = `$${discountedPrice.toFixed(1)} - Add to Cart`;
        }
        
        // Update detailed summary if available
        const summaryBody = document.querySelector('.accordionb-body');
        if (summaryBody) {
          let summaryHTML = '';
          
          // Add each frame group to summary
          Object.values(styleGroups).forEach(group => {
            summaryHTML += `
            <div class="dp_st__item">
              <div class="fl_s_bet">
                <div>
                  <p>${group.count} x ${group.style} ${group.size} ${group.border !== 'No Mat' ? group.border : ''} ${group.hasAcrylic ? '+ Acrylic' : ''}</p>
                </div>
                <div>
                  <span>$${(group.price * group.count).toFixed(2)}</span>
                </div>
              </div>
            </div>`;
          });
          
          // Add discount if applicable
          if (discountAmount && discountAmount > 0) {
            const discountLabel = discountType === 'percentage'
                ? `(${discountValue}%)`
                : `($${discountValue.toFixed(2)})`;
                
            summaryHTML += `
            <div class="dp_st__item dp_st__discount">
              <div class="fl_s_bet">
                <div>
                  <p>Discount ${discountLabel}</p>
                </div>
                <div>
                  <span>-$${discountAmount.toFixed(2)}</span>
                </div>
              </div>
            </div>`;
          }
          
          // Update summary HTML
          summaryBody.innerHTML = summaryHTML;
        }
        
        // Note: ATC button state is now managed by Pg.State and pg-main.js
        // Don't override button state here to avoid conflicts with configuration loading
        
        return true;
      } catch (error) {
        console.error('❌ Error building frames summary:', error);
        return false;
      }
    },

    allowAtcWithoutPhoto() {
      S$G("fwop").style.display = "block";
      S$G("background-overlay").style.display = "block";

      function onOverlayClick() {
        S$G("fwop").style.display = "none";
        S$G("background-overlay").style.display = "none";
      }
      const overlayEl = S$Q("#background-overlay");
      overlayEl.addEventListener("click", onOverlayClick);

      S$Q(".fwopUpload").addEventListener(
        "click",
        function () {
          if(overlayEl) overlayEl.removeEventListener("click", onOverlayClick);
          // S$G("uploadButton").click();
          S$Q(".btns-group").dispatchEvent(
            new MouseEvent("click", {
              bubbles: true,
              cancelable: true,
              view: window
            })
          );
          S$G("fwop").style.display = "none";
          S$G("background-overlay").style.display = "none";
        },
        { once: true }
      );
      S$Q(".fwopDiscard").addEventListener(
        "click",() => {
          if(overlayEl) overlayEl.removeEventListener("click", onOverlayClick);
          S$G("fwop").style.display = "none";
          S$G("background-overlay").style.display = "none";
          this.addToCartWithOutImages();
        },
        { once: true }
      );
    },

    /**
     * Add frames to cart without photo
     * Handles the main "Add to Cart" operation for all frames
     * @returns {Promise<boolean>} - Success status
     */
    async addToCartWithOutImages() {
      cLog('🛒 Pg.Cart: Adding all frames to cart without Images');
      
      // Set flag that user has tried to add to cart
      this.userTriedAddToCart = true;
      
      try {
        // Check if all uploads are complete
        const computed = w.Pg.State.data.computed;
        console.log(computed,"--");

        // Show loading state
        const a2cbtn = document.querySelector('.dp_st__atc-btn');
        if (a2cbtn) {
          a2cbtn.classList.add('loading');
          a2cbtn.innerText = 'Processing...';
        }

        // Create items array for cart
        const items = [];
        
        // Process each frame
        let { withAcrylic: acrylic,selectedBorder: border, selectedStyle: style, id,selectedSize: size} = w.Pg.State.data;
        const variantID = Pg.Utils.findPByKey(`${style}__${size.variant}`).id;

        let hie = size?.height;
        let wei = size?.width;

        acrylic = false;

        console.log({ selectedAcrylic: acrylic,selectedBorder: border, selectedStyle: style, id,selectedSize: size, variantID});

        // if(acrylic.toString() == "true"){
        //     var acr2add = w.Pg.Utils.findVariantByKeySubstring(`${Math.min(wei,hie)}x${Math.max(wei,hie)}`); 
        //     if(acr2add?.id){
        //       items.push({
        //           id: acr2add.id.toString(),
        //           quantity: 1,
        //           properties: {
        //               "_parent_frameid_": id,
        //           }  
        //       });
        //     }else{
        //       console.warn("⚠️ Skipping acrylic add-on — no valid variant ID found:", acr2add);
        //     }
           
        // }

         items.push({
            id: variantID.toString(),
            quantity: 1,
            properties: {
                "_dir_": Number(wei) >= Number(hie) ? "h" : "v",
                "_frameid_": id,
                "_width_": size?.width,
                "_height_": size?.height,
                "_acrylic_": acrylic.toString(),
                "_style_": style,
                "_acrylic-price_": acrylic.toString() == "true" ? acr2add?.price : 0,
                "_border_": border,
                "_varId_": variantID.toString(),
            }  
        });
        
        // Check if we have items to add
        if (!items.length) {
          console.warn('⚠️ No valid items found to add to cart');
          return false;
        }
        // Add items to cart via AJAX
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        })
              .then(response => response.json())
      .then(data => {
        cLog('✅ Items added to cart:', data);
        
        // Clear all frames from state/database before redirecting
        this.clearAllFrames();
        
        // Reset button state
        if (a2cbtn) {
          a2cbtn.classList.remove('loading');
          a2cbtn.innerText = 'Added To Cart';
          w.location.href = '/cart';
        }
      })
        .catch(error => {
          console.error('❌ Error adding items to cart:', error);
          
          // Reset button state on error
          if (a2cbtn) {
            a2cbtn.classList.remove('loading');
            a2cbtn.innerText = 'Try Again';
            
            setTimeout(() => {
              a2cbtn.innerText = 'Add To Cart';
            }, 3000);
          }
        });
        
        return true;
      } catch (error) {
        console.error('❌ Error in addToCartWithProducts:', error);
        
        // Reset button state on error
        const a2cbtn = document.querySelector('.dp_st__atc-btn');
        if (a2cbtn) {
          a2cbtn.classList.remove('loading');
          a2cbtn.innerText = 'Error - Try Again';
          
          setTimeout(() => {
            a2cbtn.innerText = 'Add To Cart';
          }, 3000);
        }
        
        return false;
      }
    },
  };

  // Shorthand accessors for legacy code
  const legacyFunctions = {
    buildFramesSummary: Pg.Cart.buildFramesSummary.bind(Pg.Cart)
  };
  
  // Initialize the cart module
  Pg.Cart.init();

  // Expose cart functions globally for manual testing
  if (typeof w !== 'undefined') {
    w.updateCartButton = () => Pg.Cart.updateAddToCartButton();
    w.forceAddToCart = async () => {
      // Force update computed state first
      if (Pg.State?.updateComputed) {
        Pg.State.updateComputed();
      }
      // Then try add to cart
      return await Pg.Cart.addToCartWithProducts();
    };
    w.debugCartFrames = () => {
      const frames = w.Pg.State.data.frames;
      console.group('🛒 Cart Frame Debug');
      frames.forEach((frame, index) => {
        console.log(`Frame ${index + 1}:`, {
          id: frame.id,
          variantID: frame.variantID,
          hasVariantID: !!frame.variantID,
          hasImage: !!frame.image,
          hasFilestackUrl: !!frame.image?.filestackUrl,
          imageStatus: frame.image?.status,
          hasCssStyles: !!frame.cssStyles,
          borderWidth: frame.cssStyles?.borderWidth,
          hasVisableCrop: !!frame.image?.visableCrop,
          visableCropType: typeof frame.image?.visableCrop,
          visableCrop: frame.image?.visableCrop,
          size: frame.size,
          acrylic: frame.acrylic
        });
      });
      console.groupEnd();
    };
  }
  
  // Log initialization
  cLog('✅ Pg.Cart module loaded');

})(window); 
